import { types, getParent } from "mobx-state-tree";

import I18N from '../../I18N';
import { toTitleCase } from '../../utils/stringManipulations'; 

const Param = types
  .model("Param", {
    count: types.maybeNull(types.number), 
    title: types.maybeNull(types.string),
    secondaryTitle: types.maybeNull(types.string) 
  })

const MetricsStore = types
  .model("Metrics", {
    athletesCount: types.maybeNull(Param), 
    videosCount: types.maybeNull(Param), 
    highlightsCount: types.maybeNull(Param) 
  })
  .actions(self => ({
    setClubMetrics() {
      const { ClubsStore: { currentClub }, TeamsStore: { allTeamsInfo } } = getParent(self);
      self.athletesCount = {
        count: allTeamsInfo ? allTeamsInfo.membersCount : null,
        title: toTitleCase(I18N.t("ATHLETES")), 
        secondaryTitle: ""
      };
      if (currentClub && currentClub.metrics) {
        self.videosCount = {
          count: currentClub.metrics.videosCount,
          title: toTitleCase(I18N.t("VIDEOS_RECORDED")), 
          secondaryTitle: ""
        };
        self.highlightsCount = {
          count: currentClub.metrics.highlightsCount,
          title: toTitleCase(I18N.t("HIGHLIGHTS_RECORDED")), 
          secondaryTitle: ""
        };
      }
    }, 
    setTeamMetrics(team) {
      self.athletesCount.count = team.members.players.length;
      self.videosCount.count = team.videosCount;
      self.highlightsCount.count = team.highlightsCount;
    }, 
    setCoachMetrics(teams) {
      const { TeamsStore: { getTeamById } } = getParent(self);
      const uniqueAthletesIds = [];
      let highlightsCount = 0;
      let videosCount = 0;
      teams.map(team => {
        const currentTeam = getTeamById(team._id);
        highlightsCount += currentTeam.highlightsCount;
        videosCount += currentTeam.videosCount;
        currentTeam.members.players.map(player => {
          if (!uniqueAthletesIds.includes(player._id)) {
            uniqueAthletesIds.push(player._id);
          };
        });
      });
      
      self.athletesCount.count = uniqueAthletesIds.length;
      self.videosCount.count = videosCount;
      self.highlightsCount.count = highlightsCount;
    }
  }));

export default MetricsStore;